import { useNavigate } from "react-router-dom";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import * as styled from "./TrialLessons.styled";
import { useEffect, useState } from "react";
import axios from "../../../axios";
// import { RemoveIcon } from "../../../components/RemoveIcon";
import { FaChalkboardTeacher, FaSearch, FaPlus, FaSave, FaEdit, FaStickyNote } from "react-icons/fa";
import StudentsByDate from "../../../components/StudentsByDate/StudentsByDate";
import { langs } from "../../../helpers/langs";


const statusOptions = [
  { value: "scheduled", label: "⏱️ Запланований" },
  { value: "attended", label: "✅ Відбувся" },
  { value: "joined", label: "🥳 Зайшов на навчання" },
  { value: "missed", label: "❌ Не зʼявився" },
  { value: "cancelled", label: "🛑 Скасований" },
];

const daysMap = {
  monday: "Понеділок",
  tuesday: "Вівторок",
  wednesday: "Середа",
  thursday: "Четвер",
  friday: "П'ятниця",
  saturday: "Субота",
  sunday: "Неділя"
};

function TrialLessons({ adminInfo }) {
  const navigate = useNavigate();
  const [lessons, setLessons] = useState([]);
  const [removedInTeacher, setRemovedInTeacher] = useState(false);
  const [hideRemoved, setHideRemoved] = useState(true);
  const [editingSchedule, setEditingSchedule] = useState({});
  const [scheduleUpdates, setScheduleUpdates] = useState({});
  const [search, setSearch] = useState("");
  const [editingNotes, setEditingNotes] = useState({});
  const [noteUpdates, setNoteUpdates] = useState({});

  useEffect(() => {
    axios
      .get("trial-lesson/all")
      .then((res) => {
        setLessons(res.data);
        setRemovedInTeacher(false);
      })
      .catch((err) => console.error(err));
  }, [removedInTeacher]);

  const handleRemove = (lessonId, teacherId) => {
    axios
      .delete(`trial-lesson/${lessonId}/${teacherId}`)
      .then(() => {
        const newLessons = lessons.filter((lesson) => lesson._id !== lessonId);
        setLessons(newLessons);
      })
      .catch((err) => console.error(err));
  };

  const removeFromTeacher = (lessonId, teacherId) => {
    axios
      .delete(`trial-lesson/remove-from-teacher/${lessonId}/${teacherId}`)
      .then(() => {
        setRemovedInTeacher(true);
      })
      .catch((err) => console.error(err));
  };

  const handleStatusChange = (lessonId, newStatus) => {
    axios
      .patch(`trial-lesson/update-status/${lessonId}`, { status: newStatus })
      .then((res) => {
        const updatedLesson = res.data.lesson;
        setLessons((prev) =>
          prev.map((lesson) =>
            lesson._id === lessonId
              ? { ...lesson, lessonStatus: updatedLesson.lessonStatus }
              : lesson
          )
        );
      })
      .catch((err) => console.error(err));
  };

  const handleScheduleEditToggle = (lessonId, idx, type) => {
    setEditingSchedule((prev) => ({
      ...prev,
      [lessonId]: {
        ...prev[lessonId],
        [idx]: {
          ...(prev[lessonId]?.[idx] || {}),
          [type]: !(prev[lessonId]?.[idx]?.[type] || false),
        },
      },
    }));
  };

  const hasScheduleChanged = (lessonId) => {
    const original =
      lessons.find((l) => l._id === lessonId)?.classSchedule || [];
    const updated = scheduleUpdates[lessonId];

    if (!updated) return false;

    if (original.length !== updated.length) return true;

    return original.some((item, idx) => {
      const updatedItem = updated[idx];
      if (!updatedItem) return false;
      return item.day !== updatedItem.day || item.time !== updatedItem.time;
    });
  };

  const handleScheduleChange = (lessonId, idx, field, value) => {
    const lessonSchedules =
      scheduleUpdates[lessonId] ||
      lessons.find((l) => l._id === lessonId).classSchedule;
    const updatedSchedule = [...lessonSchedules];
    updatedSchedule[idx] = {
      ...updatedSchedule[idx],
      [field]: value,
    };
    setScheduleUpdates((prev) => ({
      ...prev,
      [lessonId]: updatedSchedule,
    }));
  };

  const handleSaveSchedule = (lessonId) => {
    axios
      .patch(`trial-lesson/update-schedule/${lessonId}`, {
        classSchedule: scheduleUpdates[lessonId],
      })
      .then(() => {
        setLessons((prev) =>
          prev.map((l) =>
            l._id === lessonId
              ? { ...l, classSchedule: scheduleUpdates[lessonId] }
              : l
          )
        );
        setEditingSchedule((prev) => ({ ...prev, [lessonId]: {} }));
      })
      .catch((err) => console.error(err));
  };

  // Функции для работы с заметками
  const handleNoteEditToggle = (lessonId) => {
    setEditingNotes((prev) => ({
      ...prev,
      [lessonId]: !prev[lessonId]
    }));
    
    // Инициализируем значение для редактирования
    if (!noteUpdates[lessonId]) {
      const lesson = lessons.find(l => l._id === lessonId);
      setNoteUpdates((prev) => ({
        ...prev,
        [lessonId]: lesson?.notes || ""
      }));
    }
  };

  const handleNoteChange = (lessonId, value) => {
    setNoteUpdates((prev) => ({
      ...prev,
      [lessonId]: value
    }));
  };

  const handleSaveNote = (lessonId) => {
    const updatedNote = noteUpdates[lessonId] || "";
    console.log(updatedNote)
    axios
      .patch(`update-notes/${lessonId}`, { notes: updatedNote })
      .then((res) => {
        const updatedLesson = res.data.lesson;
        setLessons((prev) =>
          prev.map((lesson) =>
            lesson._id === lessonId
              ? { ...lesson, notes: updatedLesson.notes }
              : lesson
          )
        );
        setEditingNotes((prev) => ({ ...prev, [lessonId]: false }));
      })
      .catch((err) => console.error(err));
  };

  const handleCancelNoteEdit = (lessonId) => {
    setEditingNotes((prev) => ({ ...prev, [lessonId]: false }));
    // Восстанавливаем оригинальное значение
    const lesson = lessons.find(l => l._id === lessonId);
    setNoteUpdates((prev) => ({
      ...prev,
      [lessonId]: lesson?.notes || ""
    }));
  };

  const formatSchedule = (schedule) => {
    return schedule.map(({ day, time }) => (
      <styled.ScheduleChip key={`${day}-${time}`}>
        📅 {daysMap[day] || day}, 🕒 {time}
      </styled.ScheduleChip>
    ));
  };

  const getStatusColor = (status) => {
    const colors = {
      scheduled: "#ffd700",
      attended: "#4caf50",
      joined: "#2196f3",
      missed: "#f44336",
      cancelled: "#9e9e9e"
    };
    return colors[status] || "#9e9e9e";
  };

  const truncateNote = (note, maxLength = 100) => {
    if (!note) return "";
    return note.length > maxLength ? `${note.substring(0, maxLength)}...` : note;
  };

  return (
    <PagesWrapper>
      <TopPageTitle value="Пробні уроки" />

      {/* Controls */}
      <styled.ControlsContainer>
        {adminInfo.accessType !== "all" && (
          <styled.FilterSection>
            <styled.FilterLabel>
              <styled.ToggleSwitch 
                checked={hideRemoved} 
                onClick={() => setHideRemoved(!hideRemoved)}
              >
                <styled.ToggleThumb checked={hideRemoved} />
              </styled.ToggleSwitch>
              {!hideRemoved ? 'Приховати' : 'Показати'} пройдені уроки
            </styled.FilterLabel>
            
            <styled.AddButton onClick={() => navigate("add-trial-lesson")}>
              <FaPlus />
              Додати пробний урок
            </styled.AddButton>
          </styled.FilterSection>
        )}

        <styled.SearchContainer>
          <FaSearch />
          <styled.SearchInput
            type="text"
            placeholder="Пошук за імʼям, ID або нотатками..."
            value={search}
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
          />
        </styled.SearchContainer>
      </styled.ControlsContainer>

      {/* Table */}
      <styled.TableContainer>
        {adminInfo.accessType === "all" ? (
          // All Admin View - Columns by Language
          <styled.ColumnsGrid>
            {langs.map(({ key, value }) => (
              <styled.LanguageColumn key={key}>
                <styled.ColumnHeader>
                  <styled.ColumnTitle>{value}</styled.ColumnTitle>
                  <styled.CountBadge>
                    {lessons.filter(lesson => lesson.accessType === key).length}
                  </styled.CountBadge>
                </styled.ColumnHeader>
                
                <styled.CardsList>
                  {lessons
                    .filter(
                      (lesson) =>
                        lesson.accessType === key &&
                        (lesson.name.toLowerCase().includes(search) ||
                         lesson.studentId.toString().includes(search) ||
                         (lesson.notes && lesson.notes.toLowerCase().includes(search)))
                    )
                    .map((lesson) => (
                      <styled.Card key={lesson._id}>
                        <styled.CardHeader>
                          <styled.StudentInfo>
                            <styled.StudentName>{lesson.name}</styled.StudentName>
                            <styled.StudentId>ID: {lesson.studentId}</styled.StudentId>
                          </styled.StudentInfo>
                        </styled.CardHeader>
                        
                        <styled.TeacherInfo>
                          <FaChalkboardTeacher />
                          {lesson.teacherName} (ID: {lesson.teacherSchoolId})
                        </styled.TeacherInfo>
                        
                        <styled.ScheduleContainer>
                          {formatSchedule(lesson.classSchedule)}
                        </styled.ScheduleContainer>

                        {/* Notes for All Admin view */}
                        {lesson.notes && (
                          <styled.NotesSection>
                            <styled.NotesLabel>
                              <FaStickyNote />
                              Нотатки:
                            </styled.NotesLabel>
                            <styled.NotesText>{lesson.notes}</styled.NotesText>
                          </styled.NotesSection>
                        )}
                      </styled.Card>
                    ))}
                </styled.CardsList>
              </styled.LanguageColumn>
            ))}
          </styled.ColumnsGrid>
        ) : (
          // Regular Admin View - Table
          <styled.Table>
            <styled.TableHead>
              <styled.TableRow>
                <styled.TableHeader>Студент</styled.TableHeader>
                <styled.TableHeader>Викладач</styled.TableHeader>
                <styled.TableHeader>Контакти</styled.TableHeader>
                <styled.TableHeader>Розклад</styled.TableHeader>
                <styled.TableHeader>Нотатки</styled.TableHeader>
                <styled.TableHeader>Статус</styled.TableHeader>
                <styled.TableHeader>Дії</styled.TableHeader>
              </styled.TableRow>
            </styled.TableHead>
            
            <styled.TableBody>
              {lessons
                .filter(
                  (lesson) =>
                    (lesson.name.toLowerCase().includes(search) ||
                     lesson.studentId.toString().includes(search) ||
                     (lesson.notes && lesson.notes.toLowerCase().includes(search))) &&
                    (!hideRemoved || lesson.teacherId !== "removed")
                )
                .map((lesson) => (
                  <styled.TableRow key={lesson._id} isRemoved={lesson.teacherId === "removed"}>
                    <styled.TableCell>
                      <styled.StudentInfo>
                        <styled.StudentName>{lesson.name}</styled.StudentName>
                        <styled.StudentId>ID: {lesson.studentId}</styled.StudentId>
                        <styled.StudentDetails>
                          <span>Вік: {lesson.ageGroup}</span>
                          <span>Рівень: {lesson.englishLevel}</span>
                        </styled.StudentDetails>
                      </styled.StudentInfo>
                    </styled.TableCell>
                    
                    <styled.TableCell>
                      <styled.TeacherInfo>
                        <FaChalkboardTeacher />
                        <div>
                          <div>{lesson.teacherName}</div>
                          <styled.TeacherId>ID: {lesson.teacherSchoolId}</styled.TeacherId>
                        </div>
                      </styled.TeacherInfo>
                      {lesson.tokens.length > 0 && (
                        <styled.PlatformBadge>🟢 На платформі</styled.PlatformBadge>
                      )}
                    </styled.TableCell>
                    
                    <styled.TableCell>
                      <styled.ContactInfo>{lesson.phoneNumber}</styled.ContactInfo>
                    </styled.TableCell>
                    
                    <styled.TableCell>
                      <styled.ScheduleContainer>
                        {lesson.classSchedule.map(({ day, time }, idx) => {
                          const isEditingDay = editingSchedule[lesson._id]?.[idx]?.editingDay;
                          const isEditingTime = editingSchedule[lesson._id]?.[idx]?.editingTime;
                          const currentUpdate = scheduleUpdates[lesson._id]?.[idx] || { day, time };

                          return (
                            <styled.ScheduleItem key={idx}>
                              {isEditingDay ? (
                                <styled.Select
                                  value={currentUpdate.day}
                                  onChange={(e) => handleScheduleChange(lesson._id, idx, "day", e.target.value)}
                                >
                                  <option value="">Оберіть день</option>
                                  {Object.entries(daysMap).map(([key, value]) => (
                                    <option key={key} value={key}>{value}</option>
                                  ))}
                                </styled.Select>
                              ) : (
                                <styled.EditableField
                                  onClick={() => handleScheduleEditToggle(lesson._id, idx, "editingDay")}
                                >
                                  📅 {daysMap[day] || day}
                                </styled.EditableField>
                              )}
                              
                              {isEditingTime ? (
                                <styled.TimeInput
                                  type="time"
                                  value={currentUpdate.time}
                                  onChange={(e) => handleScheduleChange(lesson._id, idx, "time", e.target.value)}
                                />
                              ) : (
                                <styled.EditableField
                                  onClick={() => handleScheduleEditToggle(lesson._id, idx, "editingTime")}
                                >
                                  🕒 {time}
                                </styled.EditableField>
                              )}
                            </styled.ScheduleItem>
                          );
                        })}
                        
                        {hasScheduleChanged(lesson._id) && (
                          <styled.SaveButton onClick={() => handleSaveSchedule(lesson._id)}>
                            <FaSave />
                            Зберегти розклад
                          </styled.SaveButton>
                        )}
                      </styled.ScheduleContainer>
                    </styled.TableCell>
                    
                    {/* Notes Cell */}
                    <styled.TableCell>
                      <styled.NotesContainer>
                        {editingNotes[lesson._id] ? (
                          <>
                            <styled.NotesTextarea
                              value={noteUpdates[lesson._id] || ""}
                              onChange={(e) => handleNoteChange(lesson._id, e.target.value)}
                              placeholder="Введіть нотатку..."
                             
                            />
                            <styled.NotesActions>
                              <styled.SaveButton onClick={() => handleSaveNote(lesson._id)}>
                                <FaSave />
                                Зберегти
                              </styled.SaveButton>
                              <styled.CancelButton onClick={() => handleCancelNoteEdit(lesson._id)}>
                                Скасувати
                              </styled.CancelButton>
                            </styled.NotesActions>
                          </>
                        ) : (
                          <>
                            <styled.NotesDisplay 
                              onClick={() => handleNoteEditToggle(lesson._id)}
                              hasNotes={!!lesson.notes}
                            >
                              <FaStickyNote />
                              {lesson.notes ? truncateNote(lesson.notes) : "Додати нотатку..."}
                            </styled.NotesDisplay>
                            {/* {lesson.notes && ( */}
                              <styled.EditNoteButton onClick={() => handleNoteEditToggle(lesson._id)}>
                                <FaEdit />
                              </styled.EditNoteButton>
                            {/* )} */}
                          </>
                        )}
                      </styled.NotesContainer>
                    </styled.TableCell>
                    
                    <styled.TableCell>
                      <styled.StatusSelect
                        value={lesson.lessonStatus || "scheduled"}
                        onChange={(e) => handleStatusChange(lesson._id, e.target.value)}
                        style={{ borderLeft: `4px solid ${getStatusColor(lesson.lessonStatus)}` }}
                      >
                        {statusOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </styled.StatusSelect>
                    </styled.TableCell>
                    
                    <styled.TableCell>
                      <styled.ActionsContainer>
                        {lesson.teacherId === "removed" ? (
                          <styled.RemoveButton onClick={() => handleRemove(lesson._id, lesson.teacherId)}>
                            Видалити
                          </styled.RemoveButton>
                        ) : (
                          <styled.SecondaryButton onClick={() => removeFromTeacher(lesson._id, lesson.teacherId)}>
                            Вилучити
                          </styled.SecondaryButton>
                        )}
                      </styled.ActionsContainer>
                    </styled.TableCell>
                  </styled.TableRow>
                ))}
            </styled.TableBody>
          </styled.Table>
        )}
      </styled.TableContainer>

      <StudentsByDate
        route={"trial-lesson/by-date"}
        isTrial
        statusOptions={statusOptions}
      />
    </PagesWrapper>
  );
}

export default TrialLessons;